/**
 * External links and addresses that the backend's emails and the client's
 * footers and nav both use. Kept here so the apps share one copy instead of
 * hand-mirrored ones that have to be kept byte-identical.
 */

/**
 * CDW Amplified IT's Google Workspace domain: the support mailbox lives on it,
 * and platform admins sign in with it (`ADMIN_DOMAIN_AMPLIFIEDIT`).
 */
export const AMPLIFIEDIT_DOMAIN = 'amplifiedit.cdw.com';

/**
 * The Gopher support team's mailbox — also the From address on every email the
 * apps send through Mandrill, so a recipient's reply reaches a person. The
 * domain must be verified in Mandrill (DKIM), or mail is rejected under its
 * DMARC `p=reject` policy.
 */
export const GOPHER_SUPPORT_EMAIL = `support@${AMPLIFIEDIT_DOMAIN}`;

/** The From name paired with {@link GOPHER_SUPPORT_EMAIL} on outgoing email. */
export const GOPHER_SUPPORT_SENDER_NAME = 'Gopher for Chrome Premium';

/** "Contact Support" / "Contact the Gopher Support Team" destination. */
export const GOPHER_SUPPORT_MAILTO = `mailto:${GOPHER_SUPPORT_EMAIL}?subject=Gopher%20for%20Chrome%20Premium%20Support%20Request`;

/** CDW Education privacy notice (linked from the app footers and emails). */
export const CDW_EDUCATION_PRIVACY_URL =
  'https://www.cdw.com/content/cdw/en/terms-conditions/privacy-notice/education-privacy-disclosures.html';

/** The CDW·Gopher for Chrome Premium marketing page the footer wordmark links to. */
export const GOPHER_MARKETING_URL =
  // NOTE: `cm_mmc` is a marketing campaign id, NOT prose — it must stay
  // byte-identical to the code marketing tracks. A product-rename sweep
  // rewrote the `Gopher` inside it once already, which silently broke
  // attribution.
  'https://www.cdwg.com/content/cdwg/en/services/amplified-services/gopher.html?cm_mmc=vanity-_-Gopher-_-Oct25';
